import Select from 'components/Input/dropdown/Dropdown';
import Modal from 'components/Modal';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import services from 'services';
import actions from 'state/actions';
import selectors from 'state/selectors';
import appHelpers from 'utils/helpers/app.helpers';
import intlHelper from 'utils/helpers/intl.helper';

const ReassignPriority = () => {
  const t = intlHelper.useTranslator();
  const userCode = useSelector(selectors.user.getIdUser);
  const protocols = useSelector(selectors.documents.selectAllActiveDocumentsID);
  const documents = useSelector(selectors.documents.selectTableRows);
  const rows = useSelector(selectors.documents.selectTableRows);
  const dispatch = useDispatch();
  const idProgram = useSelector(selectors.app.getProgramCode);

  const options = [
    { label: t('normal'), value: '0' },
    { label: t('medium'), value: '1' },
    { label: t('high'), value: '2' },
    { label: t('critical'), value: '3' },
  ];

  const [priority, setPriority] = useState(documents[0].priority || '0');

  useEffect(() => {
    return () => {
      setPriority(0);
    };
  }, []);

  const handleConfirm = async () => {
    if (userCode) {
      const updatedRows = rows.map((row: any) => {
        if (protocols.includes(row.protocol)) {
          return { ...row, priority };
        }
        return row;
      });

      try {
        const { data } = await services.changePriority({
          priority,
          idCompany: documents[0].idCompany,
          protocols,
          idProgram,
          idUser: userCode,
        });
        dispatch(actions.documents.setDocumentGridRows(updatedRows));
        appHelpers.notify('success', t(data));
      } catch (err) {
        console.error(err);
      }

      dispatch(actions.modal.closeModal());
    }
  };

  return (
    <>
      <Modal.Header title={t('change-priority')} subtitle={t('description-change-priority')} />
      <Modal.Content>
        <Select
          id="priority-dropdown"
          value={options[priority]}
          onChange={(e) => setPriority(Number(e.value))}
          options={options}
        />
      </Modal.Content>
      <Modal.Footer confirmAction={handleConfirm} />
    </>
  );
};

export default ReassignPriority;
